// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4596":"99239694","5660":"5ab78bb2","6557":"5ab78bb2","6842":"6bd8d85d","6908":"5a980d15","7260":"5ab78bb2","7968":"25aa806d","8980":"5ab78bb2"}[chunkId] + ".chunk.css";
};